import React from 'react'

import { LuCode, LuEye } from 'react-icons/lu'

import IconButton from '@/components/common/IconButtonV2'

interface SourceToggleProps {
  showsSource: boolean
  onToggle: () => void
}

/**
 * Switches a rendered preview (markdown, HTML) and its source, floating over
 * the preview's top-right corner.
 */
export const SourceToggle: React.FC<SourceToggleProps> = ({
  showsSource,
  onToggle,
}) => (
  <IconButton
    aria-label={showsSource ? 'View preview' : 'View source'}
    tooltip={showsSource ? 'View preview' : 'View source'}
    aria-pressed={showsSource}
    onClick={onToggle}
    className="absolute right-5 top-3 z-10 border border-primary-200 bg-white/90 shadow-sm backdrop-blur-sm dark:border-primary-700 dark:bg-primary-900/90"
  >
    {showsSource ? <LuEye size={16} /> : <LuCode size={16} />}
  </IconButton>
)
